// Utility to build a referral link with UTM params for clean attribution
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

export function buildReferralLink(referralCode, source = "whatsapp", campaign = "share") {
  if (!referralCode) return ORIGIN;
  const params = new URLSearchParams({
    ref: referralCode,
    utm_source: source,
    utm_medium: "referral",
    utm_campaign: `${campaign}_${referralCode}`,
  });
  return `${ORIGIN}/auth?${params.toString()}`;
}
